import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { ProjectProvider } from './context/ProjectContext'
import AppLayout from './components/layout/AppLayout'
import LoginPage from './pages/LoginPage'
import Dashboard from './pages/Dashboard'
import ProjectPage from './pages/ProjectPage'
import TaskPage from './pages/TaskPage'
import MyTasks from './pages/MyTasks'
import DepartmentPage from './pages/DepartmentPage'
import TranscriptsPage from './pages/TranscriptsPage'
import AdminPage from './pages/AdminPage'
import SettingsPage from './pages/SettingsPage'
import AIChatPage from './pages/AIChatPage'

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-100">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-brand-500 border-t-transparent"></div>
      </div>
    )
  }

  if (!user) {
    return <LoginPage />
  }

  return (
    <ProjectProvider>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/projects/:projectId" element={<ProjectPage />} />
          <Route path="/tasks/:taskId" element={<TaskPage />} />
          <Route path="/my-tasks" element={<MyTasks />} />
          <Route path="/departments/:departmentId" element={<DepartmentPage />} />
          <Route path="/transcripts" element={<TranscriptsPage />} />
          <Route path="/ai-chat" element={<AIChatPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ProjectProvider>
  )
}

export default App
